import { NAVIGATION } from '@Constants/types';

export function HeaderMenuToggle(boolean) {
    return dispatch =>
        dispatch({
            type: NAVIGATION.HEADER_MENU_TOGGLE,
            payload: boolean
        });
}
